export const SETTINGS_ROUTE = 'ustawienia';
